import React from 'react';
import { Link } from 'react-router-dom';

import home_icon from '../../assets/frontend/images/home_icon.png';
import videos_icon from '../../assets/frontend/images/videos_icon.png';
import payments_icon from '../../assets/frontend/images/payments_icon.png';
import account_icon from '../../assets/frontend/images/account_icon.png';

function Dashboard() {

	return (
		<div className="body-content bg-fff pt-70l-110m-60s pb-40">

			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-left">
						<div className="font-source-sans font-size-20 font-weight-800 txt-dark-blue bb1-dark-blue uppercase pb-5">Dashboard</div>
					</div>
				</div>
			</div>

			<div className="panel large">
				<div className="grid-x">
					<div className="large-2 medium-2 small-4 cell pt-40 text-center">
						<Link to="/member/videos" className="button icon-dashboard image-container no-underline">
							<img src={videos_icon} alt="videos_icon" width="38" className="pt-10 pb-5" />
							<div className="font-source-sans font-size-11 font-weight-600 letter-spacing-0px uppercase">Videos</div>
						</Link>
					</div>
					<div className="large-2 medium-2 small-4 cell pt-40 text-center">
						<Link to="/member/payments" className="button icon-dashboard image-container no-underline">
							<img src={payments_icon} alt="payments_icon" width="38" className="pt-10 pb-5" />
							<div className="font-source-sans font-size-11 font-weight-600 letter-spacing-0px uppercase">Payments</div>
						</Link>
					</div>
				</div>
			</div>

		</div>

	);
}

export default Dashboard;